export const environment = {
    production: false,
    preprod: false,
    staging: true,
    userManualDocs:
        'https://drive.google.com/drive/folders/1jyVeDeziVfgtXVu75tC1mWtkxkKA4-1U', // for training
    secretKey: 'eab74d04-bb8f-41bd-8a8c-5a3a90fc3c37',

    firebase: {
        apiKey: 'AIzaSyDkRgoY5k2kgdqrGaHqvGDFqaFr18U-0o0',
        authDomain: 'lokos-90709.firebaseapp.com',
        projectId: 'lokos-90709',
        storageBucket: 'lokos-90709.appspot.com',
        messagingSenderId: '690583887786',
        appId: '1:690583887786:web:ba86328dedab133dd5d5d3',
        measurementId: 'G-809CC885YE',
    },
    keycloak: {
        issuer: ' https://identity.lokos.in/',
        realm: 'lokos',
        clientId: 'web-console',
        scope: 'openid',
    },

    cdnUrl: 'https://cdn.lokos.in/lokos-masterdata/',
    keyclockCdnUrl: 'https://cdn.lokos.in/keycloak/',

    keyClockApiBaseUrl: 'https://admin.lokos.in/',
    fdmApiBaseUrl: 'https://stage-fdm.lokos.in/',
    reportsApiBaseUrl: 'https://stageprod.lokos.in/',
    aajeevikaApiBaseUrl: 'https://aajeevika-stage.lokos.in/',
    cadreApiBaseUrl: 'https://stage-cadmob.lokos.in/',

    cadreSubscriptionKey: 'af33e1a7aeaf40b68326f85d7ba85a1f',
    reportSubscriptionKey: '5598bad5185c48efb912531c1fd18dcd',
    ocpApimSubscriptionKey: 'b09d4f667e604ebba5b3de0da9ab896f',
    keyClockSubscriptionKey: '7511f1a237fa45898f255dd4a52b2282',
    profileSubscriptionKey: '1c27af6b8cd2402da9290b9e0e8c3f48',
    fileUploadBaseUrl: 'https://apis.lokos.in',
    vaultBaseUrls: [
        'https://apis.lokos.in/vault/',
        'https://apis.lokos.in/vault-uat/',
    ],
    apiBaseUrl: 'https://api.lokos.in/',
    newBaseUrl: 'https://api.lokos.in/api/vault/profile/v1/',

    enableEncryption: true,
    bharatMap: {
        url: `https://gismap1.nic.in/nicstreet/rest/services/BharatMapService/Admin_boundary_GramPanchayat/MapServer`,
        token: 'ljDnhzRDPC0qPPYb20HGxtMZImN6EJT77tD03cgPYGmmS2G8iRZshTpAhw2TmtKyfmqIeL2dE0WDRN7oD8nYWw..'
    },
};
